import type { InternalUrl } from '@tbitop/routing';
import { useLink } from '@tbitop/routing';
import { omit } from 'lodash-es';
import type { ComponentProps } from 'react';
import { IconButton } from './icon-button';

export type LinkIconButtonProps = ComponentProps<typeof IconButton> & {
  href: string | InternalUrl;
};

export const LinkIconButton = (props: LinkIconButtonProps) => {
  const Link = useLink();
  return (
    <Link href={props.href}>
      {/* <span> prevents this error: */}
      {/* Warning: Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()? */}
      <span>
        <IconButton {...omit(props, ['href'])} />
      </span>
    </Link>
  );
};
